var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.415 6.587c.78.78.78 2.048 0 2.83-.781.78-2.048.78-2.83 0a2 2 0 1 1 2.83-2.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 8c0-.44.101-.874.297-1.275v0C3.307 4.661 5.54 3.333 8 3.333c2.46 0 4.693 1.328 5.703 3.392v0c.196.4.297.836.297 1.275 0 .44-.101.874-.297 1.275v0c-1.01 2.064-3.242 3.392-5.703 3.392-2.46 0-4.693-1.328-5.703-3.392v0A2.898 2.898 0 0 1 2 8",
    clipRule: "evenodd"
  })));
};
export { SvgEye as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYzA4ZjEwOTBkMmQ1NzgwMzIxOWY3MWYxNDFiMmY1YzIuc3ZnIjs=";